import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import { getBranchCampaignName, getLinkData } from "web/script/utils/branch-io";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import Button from "web/react/components/button/button";
import analytics from "web/script/analytics/analytics";

function BranchLink(_ref) {
  var title = _ref.title,
      className = _ref.className,
      children = _ref.children,
      eventLabel = _ref.eventLabel,
      branchLink = _ref.branchLink,
      primaryButton = _ref.primaryButton,
      appDeepLinkURL = _ref.appDeepLinkURL,
      financialIncentiveWebviewToken = _ref.financialIncentiveWebviewToken;
  var trackedClick = useClickTracker("web_to_app", "click", eventLabel, true, {
    campaign_name: getBranchCampaignName(branchLink)
  });

  var _useState = useState(branchLink),
      _useState2 = _slicedToArray(_useState, 2),
      branchHref = _useState2[0],
      setBranchHref = _useState2[1];

  useEffect(function () {
    function updateHref() {
      var branchReferralLink = new URL(branchLink);
      var branchIOLinkData = getLinkData(appDeepLinkURL, financialIncentiveWebviewToken);

      for (var branchDataProperty in branchIOLinkData) {
        branchReferralLink.searchParams.set(branchDataProperty, branchIOLinkData[branchDataProperty]);
      }

      setBranchHref(branchReferralLink.toString());
    }

    updateHref();
    analytics.on("pageViewIdChanged", updateHref);
    return function cleanup() {
      analytics.off("pageViewIdChanged", updateHref);
    };
  }, [branchLink, appDeepLinkURL, financialIncentiveWebviewToken]);

  if (primaryButton) {
    return React.createElement(Button, {
      onClick: trackedClick,
      styleType: "primary",
      href: branchHref,
      disabled: false,
      fullWidth: true,
      fullHeight: false,
      openInNewTab: false,
      className: className ? className : "",
      "aria-label": title
    }, title);
  }

  return React.createElement("a", {
    onClick: trackedClick,
    className: className,
    href: branchHref,
    title: title,
    "aria-label": title
  }, children);
}

export default BranchLink;